import { AxiosInstance } from 'axios';

import { FAIL_REPORT_STATUS } from '@/model/FailReport/FailReport';
import { FailReportItem } from '@/model/FailReport/FailReportItem';

import FailReportApi from './FailReportApi';

class FailReportRepository {
  failReportApi: FailReportApi;

  constructor(axiosInstance: AxiosInstance) {
    this.failReportApi = new FailReportApi(axiosInstance);
  }

  saveFailReportItems = async (FailReportsItemData: FailReportItem[], failReportId: number) => {
    try {
      const FailReports = FailReportsItemData.map(item => ({
        ...item,
        report: failReportId,
      }));
      const promises: Promise<any>[] = [];

      FailReports.forEach(item => {
        if (!item.id && !item.toDelete) {
          promises.push(this.failReportApi.createFailReportItem(item));
        } else if (item.id && item.toDelete) {
          promises.push(this.failReportApi.deleteFailReportItem(item));
        } else if (item.id && item.toUpdate) {
          promises.push(this.failReportApi.updateFailReportItem(item));
        }
      });
      await Promise.all(promises);
    } catch (error) {
      console.error('Error saving fail report items:', error);
      throw error;
    }
  };

  updateFailReportItem = async (id, FailReportItemData: Partial<FailReportItem>) => {
    try {
      const response = await this.failReportApi.updateFailReportItem({ id, ...FailReportItemData });

      return response.data;
    } catch (error) {
      console.error('Error updating fail report item:', error);
      throw error;
    }
  };

  getFailReportItems: (failReportId: number) => Promise<FailReportItem[]> = async (
    failReportId: number,
  ) => {
    try {
      const response = await this.failReportApi.getFailReportItems(failReportId);

      return response.data;
    } catch (error) {
      console.error('Error fetching fail report items:', error);
      throw error;
    }
  };

  /** Actualiza el estado de un informe de falla */
  updateFailReportStatus = async (failReportId: number, status: FAIL_REPORT_STATUS) => {
    return this.failReportApi.updateFailReportStatus(failReportId, status);
  };
}

export default FailReportRepository;
